import {
  AfterContentInit, AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input, OnDestroy,
  Output
} from "@angular/core";

@Component({
  selector: 'int-scroll-container, [intScrollContainer]',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./int-scrollbar-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntScrollContainerComponent implements AfterViewInit, OnDestroy {
  @Input() disable = false;
  @Output() onVerticalStart = new EventEmitter();
  @Output() onVerticalEnd = new EventEmitter();
  @Output() onVerticalMiddle = new EventEmitter();
  @Output() onVerticalScrollLacking = new EventEmitter();

  clearId: any = null;

  constructor(
    readonly elementRef: ElementRef
  ) {}

  ngAfterViewInit() {
    this.verticalScrollCheck();
  }

  ngOnDestroy() {
    clearTimeout(this.clearId);
  }

  @HostBinding('attr.data-scrolling') get _dataScrolling() {
    return this.disable ? 'disable' : 'enable';
  }

  @HostListener('scroll') onScroll() {
    this.clearId = setTimeout(() => {
      this.verticalScrollCheck();
    }, 0)
  }

  get elementWidth() {
    return this.elementRef?.nativeElement?.scrollWidth;
  }

  get elementHeight() {
    return this.elementRef?.nativeElement?.scrollHeight;
  }

  verticalScrollCheck() {
    const {nativeElement} = this.elementRef;
    const height = nativeElement.offsetHeight;

    if(height === nativeElement.scrollHeight) {
      this.onVerticalScrollLacking.emit();
      return;
    }

    if(this.isWithinAllowedIndent(height + nativeElement.scrollTop, nativeElement.scrollHeight)) {
      this.onVerticalEnd.emit()
    }else if((nativeElement.clientHeight + nativeElement.scrollTop !== nativeElement.scrollHeight) && nativeElement.scrollTop !== 0) {
      this.onVerticalMiddle.emit();
    }else if(nativeElement.scrollTop === 0) {
      this.onVerticalStart.emit();
    }
  }

  isWithinAllowedIndent(value: number, target: number, indentInPX = 2) {
    return value >= target - indentInPX && value <= target + indentInPX
  }

}
